export const CHANGE_APPLICATION_FILTER_JP = "CHANGE_APPLICATION_FILTER_JP";
export const RESET_APPLICATION_FILTER_JP = "RESET_APPLICATION_FILTER_JP";

const initialState = {
  job_position_ids: null,
  min_salary: "",
  max_salary: "",
  analytic_status: "",
  jobApplicationName: "",
  stage_ids: "",
  experience: [0, 99],
  min_experience:"",
  max_experience:"",
  selectedJobPositions: [],
  start_date: null,
  end_date: null,
  order_by: "create_date",
  disabledDate: false,
  applied: false,
  job_position_names:null,
  appByJp:true,
};

export default function jobApplicationByJPFilter(state = initialState, action) {
  switch (action.type) {
    case CHANGE_APPLICATION_FILTER_JP:
      return {
        ...state,
        ...action.payload,
      };

    case RESET_APPLICATION_FILTER_JP:
      return initialState;

    default:
      return state;
  }
}
